<template>
    <admin-layout>
        <section class="px-4 md:px-5 py-4 md:py-7 space-y-7">
            <custom-info-header icon="ic:round-business" title="Brands" description="Create a new brand">
                <template v-slot:action></template>
            </custom-info-header>

            <article class="mt-10 bg-white p-5 rounded-lg">
                <article class="pb-10">
                    <article>
                        <form @submit.stop.prevent="onUpdateHandle" class="space-y-3">
                            <div>
                                <h1 class="font-bold text-md text-gray-800">Update {{ brand.name }} information</h1>
                                <p class="text-sm text-gray-600">Fill in the required fields to set up your brand.</p>
                            </div>
                            <div>
                                <custom-input 
                                    id="name"
                                    label="Name"
                                    placeholder="Name"
                                    v-model="brand.name"
                                    :validate="validate$.name"
                                />
                            </div>
                            <div>
                                <custom-button 
                                    type="submit"
                                    label="Update"
                                    class="float-right"
                                    size="xs"
                                    :isLoading="isCreateLoading"
                                />
                            </div>
                        </form>
                    </article>
                </article>
            </article>
        </section>
    </admin-layout>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AdminLayout from '@/app/layouts/AdminLayout'
import CustomInfoHeader from '@/app/components/CustomInfoHeader'
import CustomButton from "@/app/components/CustomButton"
import CustomInput from '@/app/components/CustomInput'
import { useBrand } from '@/core/composables/useBrand'

const route = useRoute();

const {
    validate$,
    brand,
    isCreateLoading,
    onUpdateHandle,
    getBrandByGuid
} = useBrand();


onMounted(async () => {
    await getBrandByGuid(route.params.guid)
})
</script>